var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticStyle: { padding: "15px", "box-sizing": "border-box" },
    style: { height: _vm.chartHeight, width: _vm.chartHeight },
    attrs: { id: _vm.chartID }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }